import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; import './styles.scss';

const ThankYouForAnswering = ({ name }) =>
    (
        <div className='thank-you-container'>
            <p>{i18n.t('engagement.thank_you_for_answering', { name })}</p>
        </div>
    );


ThankYouForAnswering.propTypes = {
    name: PropTypes.string
};

export default ThankYouForAnswering;
